export const data = [
    {
        id: '1rabbitduck',
        title:'１，「私を、どう見ているか？」から、全てが始まっている',
        value: "https://player.vimeo.com/video/315814999"
    },
    {
        id: '2identityshiftcycle',
        title:' ２，「アイデンティティ・シフト」と「自己強化サイクル」',
        value: "https://player.vimeo.com/video/315817495"
    },
    {
        id: '3enecolorrelationship',
        title:'３，「Enecolorの感情特性」と「関係性」',
        value: "https://player.vimeo.com/video/315813681"
    },
    {
        id: '4emotionsensebreath',
        title:'４，「感情」と「感覚」と「呼吸」の連動',
        value: "https://player.vimeo.com/video/315813740"
    },
    {
        id: '5breathingvoice',
        title:'５，「呼吸の開放」と「声色」と「プレゼン力」',
        value: "https://player.vimeo.com/video/316797937"
    },
    {
        id: '6breathinner',
        title:'６、「呼吸力」で「内観力」と「感情伝達力」を高める',
        value: "https://player.vimeo.com/video/316798119"
    },
    {
        id: '7heartemotionmodel',
        title:'７、「心とは？」「感情とは？」を図解した内面モデル',
        value: "https://player.vimeo.com/video/316513754"
    },
    {
        id: '8metabeing',
        title:'８、「メタ認知力」を高め「在り方を選択」する技術',
        value: "https://player.vimeo.com/video/316513883"
    },
    {
        id: '9positivegeniusinsithmap',
        title:'９、「ポジティブの罠」を脱し「天才性を発揮」するには？',
        value: "https://player.vimeo.com/video/316514069"
    },
    {
        id: '10actioninnerworld',
        title:'１０、「行動力が発揮できない時」の深層心理',
        value: "https://player.vimeo.com/video/316514279"
    },
    {
        id: '11metagoalintegration',
        title:'１１、「高次目的」と「統合」をもたらす問いの技術',
        value: "https://player.vimeo.com/video/316514485"
    },
    {
        id: '12integratedvision',
        title:'１２、「Visionの統合」と「第3の道」の開き方',
        value: "https://player.vimeo.com/video/316798233"
    },
    {
        id: '13visionsolution',
        title:'１３、「統合された高次目的」を具現化するには？',
        value: "https://player.vimeo.com/video/316798335"
    },
    {
        id: '14integrationrealitymap',
        title:'１４、「自己統合」と「自己実現」の「内なる全体地図」',
        value: "https://player.vimeo.com/video/316798455"
    },
    {
        id: '15valueoutput',
        title:'１５、抽象的な「価値」を、具体的な「事業」へ',
        value: "https://player.vimeo.com/video/316798689"
    },
    {
        id: '16identitywork',
        title:'１６、「自分の軸ど真ん中」の仕事を作るには？',
        value: "https://player.vimeo.com/video/316799067"
    },
    {
        id: '17focusbeing',
        title:'１７、自己を開放し「究極のフォーカス」を定めるには？',
        value: "https://player.vimeo.com/video/316802167"
    }
]